import { FaPlus } from 'react-icons/fa'
import { IconContext } from 'react-icons'
import { thereAreInvoiceErrors, allPersisted } from '../../../../../_helpers/transient-invoices'

import { S_InvoicesOverview_TableControls } from '../../../../ClientViews/UploadInvoices/S_UploadInvoices'
import React, { useState } from 'react'
import { tableFormat } from '../../../../../_helpers/invoices'
import { buildTransientInvoice } from '../../../../../_helpers/transient-invoices'
import { LoaderButton } from '../../../../../_components/LoaderButton'
import { S_ConfirmModal } from '../../../../LenderViews/FundingRequestPage/ConfirmModal'
import { useModal } from '../../../../../_reduxHooks/modal.hook'
import { editScheduleConstants } from '../constants'

const fixBeforeAddMoreModal = (openModal) => {
  const FixInvoicesModal = () => {
    return (
      <S_ConfirmModal>
        <h2>Save first!</h2>
        <p>Save the invoices on the current page before adding more.</p>
      </S_ConfirmModal>
    )
  }
  openModal(FixInvoicesModal, {})
}
export const EditScheduleTableControls = ({
  addNewInvoice,
  business,
  disabled,
  isLoading,
  lastDebtor,
  pageSize,
  results,
}) => {
  const [addingNewInvoice, setAddingNewInvoice] = useState(false)
  const { openModal } = useModal()
  const addInvoice = async () => {
    const pageSizeReached = results.length == pageSize
    if (pageSizeReached && (thereAreInvoiceErrors(results) || !allPersisted(results))) {
      fixBeforeAddMoreModal(openModal)
      return
    }
    setAddingNewInvoice(true)
    const transient_id = crypto.randomUUID()
    let emptyInvoice = buildTransientInvoice(transient_id, business.id, lastDebtor)
    addNewInvoice(tableFormat(emptyInvoice))
    setAddingNewInvoice(false)
  }

  // Upload

  return (
    <S_InvoicesOverview_TableControls>
      <LoaderButton
        className={`table-controls-btn compact`}
        disabled={disabled}
        icon="add"
        isLoading={isLoading || addingNewInvoice}
        onClick={() => addInvoice()}
      >
        <IconContext.Provider value={{ size: '16px', className: 'add-icon' }}>
          <FaPlus />
          {editScheduleConstants.NEW_INVOICES_BUTTON}
        </IconContext.Provider>
      </LoaderButton>
    </S_InvoicesOverview_TableControls>
  )
}
